import { defineMessages } from 'react-intl';

export default defineMessages({
  AccessCommanderRemoteCardAlertDisconnected: {
    defaultMessage:
      'Contact your Access Commander admin for more information.\n' +
      'Alternatively, click Unpair to return to a state where it can be paired again.',
    id: 'accessCommanderRemote.card.alert.disconnected',
  },
  AccessCommanderRemoteCardAlertDisconnectedTitle: {
    defaultMessage: 'Service is unavailable',
    id: 'accessCommanderRemote.card.alert.disconnected.title',
  },
  AccessCommanderRemoteCardAlertUnpaired: {
    defaultMessage: 'To use this feature, first pair Access Commander with this My2N site using a pairing key.',
    id: 'accessCommanderRemote.card.alert.unpaired',
  },
  AccessCommanderRemoteCardButton: {
    defaultMessage: 'Open Access Commander',
    id: 'accessCommanderRemote.card.button',
  },
  AccessCommanderRemoteCardButtonTooltipUnpaired: {
    defaultMessage: 'Pair with Access Commander using {br}a pairing key to continue',
    id: 'accessCommanderRemote.card.button.tooltip.unpaired',
  },
  AccessCommanderRemoteCardStatusConnected: {
    defaultMessage: 'Connected',
    id: 'accessCommanderRemote.card.status.connected',
  },
  AccessCommanderRemoteCardStatusDisconnected: {
    defaultMessage: 'Disconnected',
    id: 'accessCommanderRemote.card.status.disconnected',
  },
  AccessCommanderRemoteCardText: {
    defaultMessage:
      'Opens Access Commander in a new tab.' + '<p>Then you can log in using your Access Commander credentials.</p>',
    id: 'accessCommanderRemote.card.text',
  },
  AccessCommanderRemoteCardTitle: {
    defaultMessage: 'Access Commander Anywhere',
    id: 'accessCommanderRemote.card.title',
  },
  AccessCommanderRemoteCardUnpairButton: {
    defaultMessage: 'Unpair',
    id: 'accessCommanderRemote.card.unpair.button',
  },
  AccessCommanderRemoteCardUnpairError: {
    defaultMessage: "Couldn't unpair. Please try again.",
    id: 'accessCommanderRemote.card.unpair.error',
  },
  AccessCommanderRemoteCardUnpairSuccess: {
    defaultMessage: 'Access Commander unpaired. Generate a new pairing key to continue.',
    id: 'accessCommanderRemote.card.unpair.success',
  },
});
